exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".requested-queue-status-container.is-loading{position:absolute;top:50%;left:0px;width:100%;transform:translateY(-50%)}.requested-queue-status-container.is-loading .loading{position:relative;top:0px;transform:translateX(-50%);margin:20px 0px 20px 0px}", ""]);

